var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.isCapturable()
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("global.messages.warning.ordenRequerido")
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCapturable()
        ? _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "apeironGwApp.cronogramaActividades.label.requisitos"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-overlay",
                        {
                          attrs: {
                            show: _vm.isSearching,
                            "spinner-variant": "primary",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "align-items-center" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "d-flex justify-content-end" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        disabled: !(
                                          _vm.solicitud.estado ===
                                            "EN_CAPTURA" &&
                                          _vm.solicitud?.fechaFinMovilidad
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.abrirModalAgregar()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.cronogramaActividades.label.agregarActividad"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        disabled: !(
                                          _vm.solicitud.estado ===
                                            "EN_CAPTURA" &&
                                          _vm.solicitud?.cronogramaActividades
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.abrirModalEliminar()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.cronogramaActividades.label.eliminaUltimaActividad"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-table", {
                            staticClass: "text-nowrap mt-3",
                            attrs: {
                              responsive: "",
                              "sticky-header": "70vh",
                              "show-empty": "",
                              "head-variant": "primary",
                              items: _vm.solicitud.cronogramaActividades,
                              fields: _vm.fields,
                            },
                          }),
                          _vm._v(" "),
                          _vm.totalItems > 0
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-right",
                                      attrs: { sm: "12", md: "12", lg: "12" },
                                    },
                                    [
                                      _c("p", [
                                        _c(
                                          "small",
                                          {
                                            staticClass:
                                              "text-muted font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.table.totalRows",
                                                  { totalRows: _vm.totalItems }
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "periodoModal",
                  attrs: {
                    id: "modal-1",
                    size: "lg",
                    title: _vm.tituloModal,
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function () {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "primary",
                                  disabled: _vm.$v.$invalid,
                                },
                                on: { click: _vm.abrirModalConfirmacion },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(_vm.buttonText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.buttonIcon
                                  ? _c("span", { class: _vm.buttonIcon })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "secondary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cerrarModal()
                                  },
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.cronogramaActividades.modal.boton.cerrar"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "icon-cerrar" }),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1822026625
                  ),
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldset-9",
                                label: _vm.$t(
                                  "apeironGwApp.cronogramaActividades.label.inicioActividad"
                                ),
                                "label-for": "finicio",
                              },
                            },
                            [
                              _vm.accion !== "E"
                                ? _c("b-form-datepicker", {
                                    attrs: {
                                      id: "fechaInicio",
                                      placeholder: "",
                                      "date-format-options": {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      },
                                    },
                                    model: {
                                      value: _vm.fechaInicio,
                                      callback: function ($$v) {
                                        _vm.fechaInicio = $$v
                                      },
                                      expression: "fechaInicio",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "fieldset-10",
                                label: _vm.$t(
                                  "apeironGwApp.cronogramaActividades.label.finActividad"
                                ),
                                "label-for": "fin",
                              },
                            },
                            [
                              _vm.accion !== "E"
                                ? _c("b-form-datepicker", {
                                    attrs: {
                                      id: "fechaFin",
                                      placeholder: "",
                                      "date-format-options": {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      },
                                    },
                                    model: {
                                      value: _vm.fechaFin,
                                      callback: function ($$v) {
                                        _vm.fechaFin = $$v
                                      },
                                      expression: "fechaFin",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: !_vm.$v.fechaFin.$invalid } },
                            [
                              !_vm.$v.fechaFin.required
                                ? _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("entity.validation.required")
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _vm.accion !== "E"
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "fieldset-11",
                                    label: _vm.$t(
                                      "apeironGwApp.cronogramaActividades.label.descripcionActividad"
                                    ),
                                    "label-for": "descripcionActividad",
                                  },
                                },
                                [
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: "descripcionActividad",
                                      rows: "4",
                                    },
                                    model: {
                                      value: _vm.descripcionActividad,
                                      callback: function ($$v) {
                                        _vm.descripcionActividad = $$v
                                      },
                                      expression: "descripcionActividad",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-invalid-feedback",
                                    {
                                      attrs: {
                                        state:
                                          !_vm.$v.descripcionActividad.$invalid,
                                      },
                                    },
                                    [
                                      !_vm.$v.descripcionActividad.minLength
                                        ? _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.minlength",
                                                  { min: 10 }
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$v.descripcionActividad.maxLength
                                        ? _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.maxlength",
                                                  { max: 500 }
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.$v.descripcionActividad.required
                                        ? _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "confirmacionModal",
                  attrs: {
                    "header-bg-variant": "primary",
                    title: _vm.$t(
                      "apeironGwApp.cronogramaActividades.mensajes.tituloConfirmacion"
                    ),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function () {
                          return [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mr-3",
                                        attrs: { variant: "outline-danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.cerrarModalConfirmacion()
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "icon-cerrar",
                                        }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("entity.action.close")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.aceptarConfirmacion()
                                          },
                                        },
                                      },
                                      [
                                        [
                                          _c("span", {
                                            staticClass: "icon-check",
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("entity.action.confirm")
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3974051052
                  ),
                },
                [
                  [
                    _c(
                      "b-row",
                      { staticClass: "text-center mt-3" },
                      [
                        _c("b-col", [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.cronogramaActividades.mensajes.confirmacion",
                                  {
                                    accion: _vm.buttonText,
                                  }
                                )
                              ),
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "eliminaActividadModal",
                  attrs: {
                    id: "modal-1",
                    size: "lg",
                    title: _vm.tituloModal,
                    "no-close-on-esc": "",
                    "no-close-on-backdrop": "",
                    "hide-header-close": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-footer",
                        fn: function () {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: { click: _vm.eliminarPeriodo },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.cronogramaActividades.modal.boton.eliminar"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(_vm.buttonText),
                                  },
                                }),
                                _vm._v(" "),
                                _vm.buttonIcon
                                  ? _c("span", { class: _vm.buttonIcon })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "secondary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cerrarModalConfirmacionEliminar()
                                  },
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.cronogramaActividades.modal.boton.cerrar"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "icon-cerrar" }),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4207758933
                  ),
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.cronogramaActividades.label.eliminarActividad"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }